import { EditorProvider, useCurrentEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import TextAlign from '@tiptap/extension-text-align'
import { Button, Space } from "antd";
import {
  BoldOutlined,
  ItalicOutlined,
  StrikethroughOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
} from "@ant-design/icons";
import React from "react";
import 'react-quill/dist/quill.snow.css'

const TextEditorFunctions = () => {
  const { editor } = useCurrentEditor()

  if (!editor) {
    return null
  }

  return(
    <>
      <div className="control-group">
        <div className="button-group">
          <Space>
            <Button
              onClick={() => editor.chain().focus().toggleBold().run()}
              size="small"
              type="dashed"
              icon={<BoldOutlined />}
              htmlType="button"
              disabled={
                !editor.can()
                  .chain()
                  .focus()
                  .toggleBold()
                  .run()
              }
              className={editor.isActive('bold') ? 'is-active' : ''}
            />
            <Button
              onClick={() => editor.chain().focus().toggleItalic().run()}
              size="small"
              type="dashed"
              icon={<ItalicOutlined />}
              htmlType="button"
              disabled={
                !editor.can()
                  .chain()
                  .focus()
                  .toggleItalic()
                  .run()
              }
              className={editor.isActive('italic') ? 'is-active' : ''}
            />
            <Button
              onClick={() => editor.chain().focus().toggleStrike().run()}
              size="small"
              type="dashed"
              icon={<StrikethroughOutlined />}
              htmlType="button"
              disabled={
                !editor.can()
                  .chain()
                  .focus()
                  .toggleStrike()
                  .run()
              }
              className={editor.isActive('strike') ? 'is-active' : ''}
            />

            <Button
              onClick={() => editor.chain().focus().setTextAlign('left').run()}
              size="small"
              type="dashed"
              icon={<AlignLeftOutlined />}
              htmlType="button"
              className={editor.isActive({ textAlign: 'left' }) ? 'is-active' : ''}
            />

            <Button
              onClick={() => editor.chain().focus().setTextAlign('center').run()}
              size="small"
              type="dashed"
              icon={<AlignCenterOutlined />}
              htmlType="button"
              className={editor.isActive({ textAlign: 'center' }) ? 'is-active' : ''}
            />

            <Button
              onClick={() => editor.chain().focus().setTextAlign('right').run()}
              size="small"
              type="dashed"
              icon={<AlignRightOutlined />}
              htmlType="button"
              className={editor.isActive({ textAlign: 'right' }) ? 'is-active' : ''}
            />
          </Space>
        </div>
      </div>
    </>
  )
}

const EditorContentSync = ({ content }: { content: string }) => {
  const { editor } = useCurrentEditor()

  React.useEffect(() => {
    if (!editor) return

    const current = editor.getHTML()
    if (content !== current) {
      editor.commands.setContent(content || '', false)
    }
  }, [content, editor])

  return null
}

export const TextEditor = ({ content, returned }: any) => {

  const extensions = [
    StarterKit.configure({
      bulletList: { keepMarks: true },
      orderedList: { keepMarks: true },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
  ]

  return (
    <EditorProvider
      slotBefore={<TextEditorFunctions />}
      slotAfter={<EditorContentSync content={content ?? ''} />}
      extensions={extensions}
      content={content ?? ''}
      onUpdate={({ editor }) => returned(editor.getHTML())}
    />
  )
}
